"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTimerPinComponent = exports.isSpinnerPinComponent = exports.isTeacherPin = exports.isUneditableShapePinComponent = exports.isQuizPinAnswerImage = exports.isQuizPinAnswerText = exports.isAnswerAreaPinComponent = exports.IsVideoPinComponent = exports.isTextPinComponent = exports.isShapePinComponent = exports.isImagePinComponent = exports.isHotspotPinComponent = exports.isLinePinComponent = exports.isQuizTeacherPin = exports.isInteractiveQuestionPinTextPinComponent = exports.isInteractiveQuestionPin = exports.isWordCloudPin = exports.isOpenQuestionPin = exports.isQuizPin = exports.isSlidePin = void 0;
function isSlidePin(pin) {
    return pin.type === 'SLIDE';
}
exports.isSlidePin = isSlidePin;
function isQuizPin(pin) {
    return pin.type === 'MULTIPLE_CHOICE';
}
exports.isQuizPin = isQuizPin;
function isOpenQuestionPin(pin) {
    return pin.type === 'OPEN_QUESTION';
}
exports.isOpenQuestionPin = isOpenQuestionPin;
function isWordCloudPin(pin) {
    return pin.type === 'WORD_CLOUD';
}
exports.isWordCloudPin = isWordCloudPin;
function isInteractiveQuestionPin(pin) {
    return isQuizPin(pin) || isOpenQuestionPin(pin) || isWordCloudPin(pin);
}
exports.isInteractiveQuestionPin = isInteractiveQuestionPin;
function isInteractiveQuestionPinTextPinComponent(pin, pinComponent) {
    if (isInteractiveQuestionPin(pin) && isTextPinComponent(pinComponent)) {
        return pin.settings.questionId === pinComponent.id;
    }
    return false;
}
exports.isInteractiveQuestionPinTextPinComponent = isInteractiveQuestionPinTextPinComponent;
function isQuizTeacherPin(pin) {
    return isTeacherPin(pin) && isQuizPin(pin);
}
exports.isQuizTeacherPin = isQuizTeacherPin;
function isLinePinComponent(pinComponent) {
    return pinComponent.type === 'LINE';
}
exports.isLinePinComponent = isLinePinComponent;
function isHotspotPinComponent(pinComponent) {
    return pinComponent.type === 'HOTSPOT';
}
exports.isHotspotPinComponent = isHotspotPinComponent;
function isImagePinComponent(pinComponent) {
    return pinComponent.type === 'IMAGE';
}
exports.isImagePinComponent = isImagePinComponent;
function isShapePinComponent(pinComponent) {
    return pinComponent.type === 'SHAPE';
}
exports.isShapePinComponent = isShapePinComponent;
function isTextPinComponent(pinComponent) {
    return pinComponent.type === 'TEXT';
}
exports.isTextPinComponent = isTextPinComponent;
function IsVideoPinComponent(pinComponent) {
    return pinComponent.type === 'VIDEO';
}
exports.IsVideoPinComponent = IsVideoPinComponent;
function isAnswerAreaPinComponent(pinComponent) {
    return pinComponent.type === 'ANSWER_AREA';
}
exports.isAnswerAreaPinComponent = isAnswerAreaPinComponent;
function isQuizPinAnswerText(answer) {
    return answer.type === 'TEXT';
}
exports.isQuizPinAnswerText = isQuizPinAnswerText;
function isQuizPinAnswerImage(answer) {
    return answer.type === 'IMAGE';
}
exports.isQuizPinAnswerImage = isQuizPinAnswerImage;
function isUneditableShapePinComponent(pinComponent) {
    return pinComponent.type === 'UNEDITABLE_SHAPE';
}
exports.isUneditableShapePinComponent = isUneditableShapePinComponent;
function isTeacherPin(pin) {
    return 'teacherSettings' in pin;
}
exports.isTeacherPin = isTeacherPin;
function isSpinnerPinComponent(pinComponent) {
    return pinComponent.type === 'SPINNER';
}
exports.isSpinnerPinComponent = isSpinnerPinComponent;
function isTimerPinComponent(pinComponent) {
    return pinComponent.type === 'TIMER';
}
exports.isTimerPinComponent = isTimerPinComponent;
//# sourceMappingURL=index.js.map